<template>
  <div class="manage-banner">
    <a-card
      :bordered="false"
      class="header-solid h-full"
      :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
    >
      <a-form-model :model="form" :rules="rules" ref="form">
        <a-form-model-item class="mb-5" label="Tiêu đề" prop="title">
          <a-input v-model="form.title" placeholder="Tiêu đề" />
        </a-form-model-item>
        <a-form-model-item class="mb-5" label="Nội dung" prop="content">
          <a-input
            type="textarea"
            :rows="5"
            v-model="form.content"
            placeholder="Nội dung"
          />
        </a-form-model-item>
        <a-form-model-item class="mb-30" label="Ảnh" :colon="false">
          <input
            type="file"
            accept="image/png, image/svg, image/jpeg, image/gif, image/jpg"
            @change="onAvatarChange"
          />
        </a-form-model-item>
        <img
          v-show="avatarUrl"
          id="preview-avatar"
          :src="avatarUrl"
          class="preview-avatar"
        />
        <a-form-model-item class="mt-50">
          <a-row type="flex" justify="end">
            <a-button
              type="primary"
              :loading="callingAPI"
              @click="handleSubmit"
            >
              {{ form.id ? "Cập nhật" : "Thêm mới" }}
            </a-button>
          </a-row>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import {
  fetch,
  update,
  create,
} from "@/services/landing-page/career/career-introduce";
export default {
  name: "ManageRecruitmentProcessBanner",
  data() {
    return {
      callingAPI: false,
      form: {
        id: null,
        title: "",
        content: "",
        image: null,
        active: 1,
        post_type: 1,
        type: 3,
      },
      rules: {
        title: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
        content: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
      },
      avatarUrl: "",
    };
  },
  beforeMount() {
    this.loadData();
  },
  methods: {
    async loadData() {
      try {
        const params = {
          post_type: 1,
          type: this.form.type,
          per_page: 100,
        };
        const response = await fetch(params);
        if (response.data.data.length) {
          const currentBanner = response.data.data.pop()
          this.form.id = currentBanner.id;
          this.form.title = currentBanner.title;
          this.form.content = currentBanner.content;
          if (currentBanner.recruitment_introduce_file.length) {
            this.avatarUrl = `${process.env.VUE_APP_LANDING_PAGE_BACKEND_URL}/${currentBanner.recruitment_introduce_file[0].url_file}`;
          }
        }
      } catch (error) {}
    },

    onAvatarChange(e) {
      if (e.target.files.length) {
        const file = e.target.files[0];
        this.form.image = file;
        this.avatarUrl = URL.createObjectURL(file);
      }
    },

    async handleSubmit(e) {
      e.preventDefault();
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            this.callingAPI = true;
            if (!this.avatarUrl) {
              this.$message.error("Vui lòng upload ảnh đại diện!");
              this.callingAPI = false;
              return;
            }

            const formData = new FormData();
            formData.append("title", this.form.title);
            formData.append("content", this.form.content);
            formData.append("active", this.form.active);
            formData.append("type", this.form.type);
            formData.append("post_type", this.form.post_type);

            if (this.form.image) {
              formData.append("image[]", this.form.image);
            }

            if (this.form.id) {
              formData.append("_method", "PUT");
            }

            let response = null;
            if (this.form.id) {
              response = await update(this.form.id, formData);
            } else {
              response = await create(formData);
            }
            this.callingAPI = false;
            if (response.status == 1) {
              const message = this.form.id
                ? "Cập nhật thành công."
                : "Thêm mới thành công.";
              this.$notification.success({
                message: "Thành công",
                description: message,
              });
            } else {
              this.$notification.error({
                message: "Thất bại",
                description: response.errors[0],
              });
            }
          } catch (error) {
            this.callingAPI = false;
            console.log(error);
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#preview-avatar {
  max-width: 100%;
  object-fit: contain;
  display: block;
}
</style>